import { tt } from "../i18n/i18n";
import ReturnCodes from "./ReturnCodes";

export function getErrorTitle(code?: ReturnCodes): string {
  if (code === undefined) {
    return tt("generic_error");
  }
  switch (code) {
    case ReturnCodes.NoBillFoundForCurrentPeriod:
      return tt("impossible_action");
    default:
      return tt("error");
  }
}

export default function getErrorMessage(code?: ReturnCodes): string {
  if (code === undefined) {
    return tt("generic_error");
  }

  switch (code) {
    case ReturnCodes.Ok:
      return "";

    case ReturnCodes.NoSuchCustomer:
      return tt("error_account_not_exist");

    case ReturnCodes.PromoCodeDoesNotExist:
      return tt("error_promo_code_not_exist");

    case ReturnCodes.PromoCodeExpired:
      return tt("error_promo_code_expired");

    case ReturnCodes.PromoCodeIsAlreadyConsumed:
      return tt("error_promo_code_already_used");

    case ReturnCodes.PromoCodePlanMismatch:
      return tt("error_promo_code_plan_mismatch");

    case ReturnCodes.PromoCodeNotAuthorized:
      return tt("error_promo_code_not_authorized");

    case ReturnCodes.PromoCodeMalformed:
      return tt("error_promo_code_malformed");

    case ReturnCodes.InvalidCode:
      return tt("error_verification_code_incorrect");

    case ReturnCodes.InvalidTokenType:
      return tt("error_connection_link_malformed");

    case ReturnCodes.TokenExpired:
      return tt("error_connection_link_expired");

    case ReturnCodes.SubscriptionPromoCodeAlreadyConsumed:
      return tt("error_quote_already_used");

    case ReturnCodes.SubscriptionPromoCodeDoesNotExist:
      return tt("error_quote_no_longer_valid");

    case ReturnCodes.CustomerAlreadyExists:
      return tt("error_connection_impossible");

    case ReturnCodes.Generic:
      return tt("generic_error");

    case ReturnCodes.NoSuchPlan:
      return tt("err_NoSuchPlan");

    case ReturnCodes.Unauthorized:
      return tt("err_Unauthorized");

    case ReturnCodes.UpsellOk:
      return tt("UpsellOk");

    case ReturnCodes.UpsellOkWithCompensationBill:
      return tt("UpsellOkWithCompensationBill");

    case ReturnCodes.NoPaymentIntentProvided:
      return tt("NoPaymentIntentProvided");

    case ReturnCodes.NoSubscriptions:
      return tt("NoSubscriptions");

    case ReturnCodes.MoreThan1ActiveSubscription:
      return tt("MoreThan1ActiveSubscription");

    case ReturnCodes.NotASaaSSubscription:
      return tt("NotASaaSSubscription");

    case ReturnCodes.CannotUpgradeToTheSamePlan:
      return tt("CannotUpgradeToTheSamePlan");

    case ReturnCodes.NotTheSameCommitment:
      return tt("NotTheSameCommitment");

    case ReturnCodes.NoBillFoundForCurrentPeriod:
      return tt("NoBillFoundForCurrentPeriod");

    case ReturnCodes.UnsupportedUseCase:
      return tt("UnsupportedUseCase");

    case ReturnCodes.NoSuchSubscription:
      return `${ReturnCodes.NoSuchSubscription}`;

    case ReturnCodes.SubscriptionIsNotYours:
      return `${ReturnCodes.SubscriptionIsNotYours}`;

    case ReturnCodes.SubscriptionIsAlreadyOver:
      return `${ReturnCodes.SubscriptionIsAlreadyOver}`;

    case ReturnCodes.PDFGenerationFailed:
      return tt("error_pdf_generation_failed");

    case ReturnCodes.S3UploadFailed:
      return tt("error_s3_upload_failed");

    case ReturnCodes.LegacyBackendFailed:
      return tt("error_legacy_backend_failed");

    case ReturnCodes.ValidationFailed:
      return tt("error_validation_failed");

    case ReturnCodes.PaymentFailed:
      return tt("PaymentFailed");
  }
}
